<template>
  <div class="wrap">
    <div class="page-list">
      <div class="border-bottom">
        <div class="title">账目明细</div>
      </div>
      <div class="money border-bottom">
        <img class="img" src="@assets/icons/account1.png" />
        <div class="text-wrap">
          <div class="gray-font-12">应付未付总金额（元）</div>
          <strong style="font-size:18px;">{{ 0 | toMoney }}</strong>
        </div>
        <img class="img" src="@assets/icons/account2.png" />
        <div class="text-wrap">
          <div class="gray-font-12">已逾期 应付未付款（元）</div>
          <strong style="color:#f66;font-size:18px;">{{ 0 | toMoney }}</strong>
        </div>
        <img class="img" src="@assets/icons/account3.png" />
        <div class="text-wrap">
          <div class="gray-font-12">剩余信用额度</div>
          <strong style="color:#66CC33;font-size:18px;">{{ 0 | toMoney }}</strong>
        </div>
      </div>
      <div class="filter">
        <div class="fast-group">
          <div class="tit" style="color:#666;">快速搜索</div>
          <div class="fast-item" :class="status===null?'active':''" @click="status=null">所有</div>
          <div class="fast-item" :class="status===false?'active':''" @click="status=false">未付款</div>
          <div class="fast-item" :class="status===true?'active':''" @click="status=true">已结清</div>
        </div>
        <SearchField
          style="float:right;width:200px;"
          :small="true"
          :value.sync="searchText"
          @submit="getData()"
          placeholder="物流单/订单号"
        ></SearchField>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>订单号</th>
            <th>物流出库单号</th>
            <th>类型</th>
            <th>收款单位</th>
            <th>应付金额(元)</th>
            <th>账目产生日期</th>
            <th>最迟付款日期</th>
            <th>状态</th>
            <th>结算日期</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="it in results" :key="it.id">
            <td>{{ it.salesOrderNumber }}</td>
            <td>{{ it.logisticsNumber }}</td>
            <td>{{ it.fundTypeLiteral }}</td>
            <td>{{ it.operateOrgName }}</td>
            <td>{{ it.amount | toMoney }}</td>
            <td>{{ it.occurDate | toShortDate }}</td>
            <td>
              <span>{{ it.expiryDate | toShortDate }}&nbsp;&nbsp;</span>
              <img v-if="!it.fundSettled" src="@assets/icons/warn.png" style="width:16px;height:16px;" />
            </td>
            <td>
              <span class="badge badge-subtle badge-success" v-if="it.fundSettled">已结清</span>
              <span class="badge badge-subtle badge-dark" v-else>未结清</span>
            </td>
            <td>{{ it.settledDate | toShortDate }}</td>
          </tr>
        </tbody>
      </table>
      <div style="margin-top:30px">
        <Pagination :total="total" @page-to="getData" ref="page" />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@components/Pagination.vue";
import SearchField from "@components/SearchField.vue";

export default {
  components: {
    Pagination,
    SearchField
  },
  data() {
    return {
      searchText: "",
      status: null,
      total: 0,
      results: []
    };
  },
  watch: {
    status() {
      this.$refs.page.pageIndex = 1;
      this.searchText = "";
      this.getData();
    },
    searchText() {
      this.$refs.page.pageIndex = 1;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData(args) {
      let params = {
        criteria: {
          keyword: this.searchText,
          fundSettled: this.status
        },
        limit: args ? args.limit : this.$limit,
        offset: args ? args.offset : 0
      };
      this.$list("/pass/receivable/queryForPurchase", params, {
        success(res) {
          this.total = res.total;
          this.results = res.results;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import url("~@assets/less/vars.less");

.wrap {
  padding: 20px;
  background: #fff;
  .page-list {
    .title {
      margin-bottom: 20px;
      font-size: 24px;
    }
    .money {
      padding: 10px 0;
      overflow: hidden;
      .img {
        float: left;
      }
      .text-wrap {
        line-height: 24px;
        height: 50px;
        width: 250px;
        float: left;
      }
    }
    .filter {
      padding: 20px 0;
    }
    .table td {
      line-height: 29px;
    }
  }
}
</style>